

















































































































































































































import {Vue, Component} from 'vue-property-decorator';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import {getFirstAndEndDay, getToday, addMonth} from '@/utils/dateUtils';
import {formatCurrency} from '@/utils/formatUtils';
import ItemTable from '@/components/common/ItemTable.vue';
import AdItemTable from '@/views/statistic/promotion/AdItemTable.vue';
import ClickOutside from 'vue-click-outside';
import {namespace} from 'vuex-class';
import {i18nInObjectList} from '@/utils/i18n';
import $ from 'jquery';
import TuiGrid from 'tui-grid';
import PageBottomContent from '@/components/board/common/PageBottomContent.vue';
import {DEFAULT_DATE_RANGE, DEFAULT_TIME_RANGE} from '@/pro/components/common/datepicker/dateRange'
import {PARTNERS_SEARCH_TYPE, PARTNERS_STATUS} from '@/views/statistic/common/getPartners'
import {
  Mall,
  Grade,
  Group,
  Partner,
  GetStatisticsPromotionsAdditionalDiscountRequest, GetPartnersRequest,
} from 'supporter';
import {createExcel} from '@/components/common/grid/ExcelCreateUtil';
import debounce from 'lodash.debounce';
import BrandSearcher from '@/components/product/BrandSearcher.vue';

const mallModule = namespace('mall');

@Component({
  components: {
    CompRadioButton,
    PeriodDateCalendar,
    CompSelectBox,
    PageBottomContent,
    CompCheckBox,
    ItemTable,
    AdItemTable,
    BrandSearcher
  },
  directives: {
    ClickOutside
  }
})
export default class AdditionalDiscount extends Vue {
  // 쇼핑몰
  @mallModule.Getter('mallsGlobal') private malls!: Mall[];
  private get mallList() {
    const list: any = [];
    if (this.malls) {
      this.malls.forEach((mall) => {
        if (mall.used) {
          list.push({
            value: mall.mallNo.toString(),
            name: mall.mallName
          });
        }
      });
    }
    return list;
  }
  private contentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    onLoadSearch: false,
  };
  private summaryContentBottomOption = {};
  private discountSummary: any = [];
  private totalCount: number = 0;
  private discountContents: any = [];
  private retStartYmd: string = '';
  private retYear: string = '';
  private retMonth: string = '';
  private retDateType: string = '';
  private retEndYmd: string = '';
  private retMallName: string = '';
  private retPartnerName: string = '';
  private retPartnerNo: string = '';
  private retBrandName: string = '';
  private partnerResult: any[] = [];
  private selectedPartner: any = {};
  private showResult: boolean = false;
  private partnerName: string = '';
  private useNaverPay: boolean = false;
  private partners: Partner[] = [];
  private searchPartner = debounce((e:Event) => this.searchPartnerByKeyword(e), 500);
  private async searchPartnerByKeyword(e) {
    const value = (e.target as HTMLInputElement).value;

    if (this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo === undefined) {
      alert(this.$t('COMMON_ERR_MALLNO_NULL'));
      this.$emit('focusMallNo');
    } else {
      const isSelectedPartner = value === this.selectedPartner?.targetName;
      if(!value) {
        this.partnerReset();
        return;
      }
      if (isSelectedPartner) return;
      
      const request : GetPartnersRequest = {
        params: {
          searchType: PARTNERS_SEARCH_TYPE.partnerName,
          keyword: value,
          mallNo: Number(this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo),
          startDateTime: `${DEFAULT_DATE_RANGE.MIN} ${DEFAULT_TIME_RANGE.START}`,
          endDateTime: `${DEFAULT_DATE_RANGE.MAX} ${DEFAULT_TIME_RANGE.END}`,
          partnerStatus: PARTNERS_STATUS.active,
          contractStatuses: PARTNERS_STATUS.active + ',' + PARTNERS_STATUS.suspend,
        }
      };
      const { data } = await this.$api.getPartners(request)
      this.partners = data.contents;

      this.partnerName = value;
      this.partnerResult = [];
      this.selectedPartner = null;
      this.showResult = true;

      const filteredPartnerName = this.partners.filter(({partnerName}) => (
        partnerName.replace(new RegExp(value, 'gi'), '') !== partnerName
      ));
      filteredPartnerName.forEach(({ partnerName, partnerNo }) => {
        const showName = partnerName.replace(new RegExp(value, 'gi'), '<span>$&</span>');
        const searchedPartnerInfo = {
          showName,
          targetName: partnerName,
          targetNo: partnerNo
        }        
        this.partnerResult = [...this.partnerResult, searchedPartnerInfo]
      });
    }
  }
  private clickPartner(partner: any) {
    this.showResult = false;
    this.selectedPartner = {
      targetName: partner.targetName,
      targetNo: partner.targetNo,
      couponTargetType: 'PARTNER'
    };
    this.partnerName = partner.targetName;
  }
  private partnerReset() {
    this.partnerResult = [];
    this.selectedPartner = null;
    this.partnerName = '';
  }
  private get notReadyEditFlg() {
    let disablFlg = false;
    if (this.partnerName === '') {
      disablFlg = true;
    }
    return disablFlg;
  }

  private closeResult() {
    this.showResult = false;
    this.partnerResult = [];
    this.selectedPartner = null;
  }

  private selectedBrand = {
      targetName: '',
      targetNo: '',
      couponTargetType: 'BRAND'
  } 
  // 회원유형
  private memberTypes = [
     /*{
      memberTypeValue: 'ALL',
      memberTypeName: 'STATISTIC_PROMOTION_ALL'
    },
   {
      memberTypeValue: 'MALL',
      memberTypeName: 'STATISTIC_PROMOTION_SHOPPING_MALL_MEMBERS'
    },
    {
      memberTypeValue: 'PAYCO',
      memberTypeName: 'STATISTIC_PROMOTION_PAYCO_ID_MEMBER'
    },
    {
      memberTypeValue: 'OPENID',
      memberTypeName: 'STATISTIC_PROMOTION_ABOUT_OPENID'
    },
    {
      memberTypeValue: 'NEOID',
      memberTypeName: 'STATISTIC_PROMOTION_INTEGRATED_MANAGEMENT_MEMBER'
    }*/
  ];
  // 회원등급
  private grades = [
    {
      memberGradeNoValue: 0,
      memberGradeNoName: 'STATISTIC_PROMOTION_ALL'
    }
  ];
  // 조회기간
  private dateType: string = 'PERIOD';
  private dateTypes = [
    {
      dateTypeValue: 'PERIOD',
      dateTypeName: 'STATISTIC_PROMOTION_BY_PERIOD'
    },
    {
      dateTypeValue: 'MONTH',
      dateTypeName: 'STATISTIC_PROMOTION_MONTHLY'
    }
  ];

  // 회원그룹
  private memberGroups = [
    {
      memberGroupNoValue: 0,
      memberGroupNoName: 'STATISTIC_PROMOTION_ALL'
    }
  ];
  // 클레임 구분
  private includesClaims = [
    {
      includesClaimValue: false,
      includesClaimName: 'STATISTIC_PROMOTION_INCLUDES_NO_CLAIMS'
    },
    {
      includesClaimValue: true,
      includesClaimName: 'STATISTIC_PROMOTION_CLAIM_INCLUDED'
    }
  ];
  // 프로모션 검색
  private promotionKeywordTypes = [
    {
      promotionKeywordTypeValue: 'NAME',
      promotionKeywordTypeName: 'STATISTIC_PROMOTION_ADDITIONAL_DISCOUNT_NAME'
    },
    {
      promotionKeywordTypeValue: 'NO',
      promotionKeywordTypeName: 'STATISTIC_PROMOTION_ADDITIONAL_DISCOUNT_NUMBER'
    },
    {
      promotionKeywordTypeValue: 'REGISTRANT',
      promotionKeywordTypeName: 'STATISTIC_PROMOTION_ADDITIONAL_DISCOUNT_REGISTRANT'
    }
  ];
  // 회원 성별
  private genderTypesCheckboxOptions = {
    name: 'genderTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: 'STATISTIC_PROMOTION_SELECT_ALL'
      },
      {
        id: 'MALE',
        value: 'MALE',
        dispaly: 'STATISTIC_PROMOTION_SELECT_MALE'
      },
      {
        id: 'FEMALE',
        value: 'FEMALE',
        dispaly: 'STATISTIC_PROMOTION_SELECT_FEMALE'
      },
      {
        id: 'UNKNOWN',
        value: 'UNKNOWN',
        dispaly: 'STATISTIC_PROMOTION_SELECT_UNKNOWN'
      }
    ]
  };

  private get issuableGenderTypes() {
    if (this.getStatisticsPromotionsAdditionalDiscountRequest.params.genderTypes !== 'ALL') {
      return this.getStatisticsPromotionsAdditionalDiscountRequest.params.genderTypes.split(',');
    } else {
      return (this.$refs.issuableGenderTypes as any).valueArr;
    }
  }
  // 플랫폼 구분
  private platformTypes = {
    name: 'platformTypes',
    hasAll: true,
    noBrackets: true,
    data: [
      {
        id: 'ALL',
        value: 'ALL',
        dispaly: 'STATISTIC_PROMOTION_SELECT_ALL'
      },
      {
        id: 'PC',
        value: 'PC',
        dispaly: 'PC'
      },
      {
        id: 'MOBILE_WEB',
        value: 'MOBILE_WEB',
        dispaly: 'STATISTIC_PROMOTION_MOBILE_WEBSITE'
      },
      {
        id: 'MOBILE_APP',
        value: 'MOBILE_APP',
        dispaly: 'STATISTIC_PROMOTION_MOBILE_APP'
      }
    ]
  };

  private get issuablePlatformTypes() {
    if (this.getStatisticsPromotionsAdditionalDiscountRequest.params.platformTypes !== 'ALL') {
      return this.getStatisticsPromotionsAdditionalDiscountRequest.params.platformTypes.split(',');
    } else {
      return (this.$refs.issuablePlatform as any).valueArr;
    }
  }

  private year: number = new Date().getFullYear();
  private beginYear: number = new Date().getFullYear() - 5 >= 2017 ? new Date().getFullYear() - 5 : 2017;
  private get yearList() {
    const years = [];
    const todayYear = new Date().getFullYear();
    for (let i = this.beginYear; i <= todayYear; i++) {
      years.push({
        value: i,
        name: `${i}${this.$t('COMMON_YEAR')}`
      });
    }
    return years;
  }
  private month: number = new Date().getMonth() + 1;
  private get monthList() {
    const months = [];
    for (let i = 1; i <= 12; i++) {
      months.push({
        value: i,
        name: `${i}${this.$t('COMMON_MONTH')}`
      });
    }
    return months;
  }

  private startDate: string = addMonth(new Date(), -1);
  private endDate: string = getToday();
  private periodOption = {
    havePeriodBtn: true,
    dateType: 'Ymd',
    period: '1m',
    periodTypes: ['td', 'ytd', '1w', '1m']
  };

  private created() {
    const noData = this.$t('STATISTIC_SALES_PERIOD_INIT_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.summary1GridProps = i18nInObjectList(this, this.summary1GridProps, 'columns', 'header');
    this.summary2GridProps.options.header = i18nInObjectList(this, this.summary2GridProps.options.header, 'complexColumns', 'header');
    this.summary2GridProps = i18nInObjectList(this, this.summary2GridProps, 'columns', 'header');
    this.gridResult = i18nInObjectList(this, this.gridResult, 'columns', 'header');
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo = String(this.malls[0].mallNo);
    //this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberType = String(this.memberTypes[0].memberTypeValue);
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.includesClaim = String(this.includesClaims[0].includesClaimValue);
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionKeywordType = String(this.promotionKeywordTypes[0].promotionKeywordTypeValue);
  }
  private getStatisticsPromotionsAdditionalDiscountRequest: GetStatisticsPromotionsAdditionalDiscountRequest = {
    params: {
      couponType: '',
      displayBrandNo: '',
      endYmd: '',
      genderTypes: 'ALL',
      includesClaim: '',
      keyword: '',
      mallNo: String(this.malls && this.malls[0].mallNo),
      memberGradeNo: '',
      memberGroupNo: '',
      memberType: '',
      page: '1',
      partnerNo: '',
      platformTypes: 'ALL',
      promotionKeywordType: '',
      promotionType: 'ADDITIONAL_DISCOUNT',
      size: '30',
      startYmd: ''
    }
  };
  private async selectMall() {
    this.changeMall();
  }

  private async changeMall() {
    this.getMemberTypes();
    this.getGrades();
    this.getGroups();
  }

  private async mounted() {
    this.getMemberTypes();
    this.getGrades();
    this.getGroups();
    this.setIsNaverPayMall();
    //this.excelComprehensive();
    $('body').on('click', '.excelComprehensive', $.proxy(this.excelComprehensiveDown, this));
    $('body').on('click', '.excelDiscountNo', $.proxy(this.excelDiscountNoDown, this));
  }
  // 监听excel综合按钮点击事件
  //private excelComprehensive() {
   // let dateNow = new Date().getTime();
    private excelDownRequest = {
      params: {
        categoryDepth: '', //  要搜索的类别深度
        categoryNo: '', //  类别号
        couponType: '', //  优惠券类型
        displayBrandNo: '', //  展览品牌号
        displayCategoryNo: '', //  展览分类号
        endYmd: '', // *  结束日期
        genderTypes: '', // *  会员性别
        includesClaim: '', //  클레임구분
        keyword: '', //  검색어 입력
        mallNo: '', // * mall
        memberGradeNo: '', //  会员等级
        memberGroupNo: '', //  会员组
        memberType: '', // * 会员类型
        page: '', // * page
        partnerNo: '', //  파트너번호
        payType: '', //  支付手段
        platformTypes: '', // * 平台类型（pc web app）
        productNos: '', // 商品编号列表
        productType: '', //  商品查询标准
        promotionKeywordType: '', //  促销搜索关键字类型
        promotionType: '', //  宣传搜索类型
        saleMethodType: '', //  销售方式区分
        size: '', // * size
        startYmd: '', // *  开始日期
        discountNo: null
      }
    };

    /*$('body').on('click', '.excelComprehensive', (e) => {
      //dateNow = new Date().getTime();
      this.excelComprehensive();
      excelDownRequest.params.mallNo = this.searchAfterInfo.mallNo ? this.searchAfterInfo.mallNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo; // * mall
      excelDownRequest.params.endYmd = this.retEndYmd ? this.retEndYmd : this.startDate; // *  结束日期
      excelDownRequest.params.startYmd = this.retStartYmd ? this.retStartYmd : this.endDate; // *  开始日期
      excelDownRequest.params.genderTypes = this.searchAfterInfo.genderTypes ? this.searchAfterInfo.genderTypes : this.getStatisticsPromotionsAdditionalDiscountRequest.params.genderTypes; // *  会员性别
      excelDownRequest.params.memberType = this.searchAfterInfo.memberType ? this.searchAfterInfo.memberType : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberType; // * 会员类型
      excelDownRequest.params.platformTypes = this.searchAfterInfo.platformTypes ? this.searchAfterInfo.platformTypes : this.getStatisticsPromotionsAdditionalDiscountRequest.params.platformTypes; // * 平台类型（pc web app）
      excelDownRequest.params.page = '1';
      excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = this.retPartnerName === '-' ? '' : this.retPartnerName; //  파트너번호
      excelDownRequest.params.displayBrandNo = this.retBrandName === '-' ? '' : this.retBrandName; //  展览品牌号
      excelDownRequest.params.includesClaim = this.searchAfterInfo.includesClaim ? this.searchAfterInfo.includesClaim : this.getStatisticsPromotionsAdditionalDiscountRequest.params.includesClaim; //  클레임구분
      excelDownRequest.params.keyword = this.searchAfterInfo.keyword ? this.searchAfterInfo.keyword : this.getStatisticsPromotionsAdditionalDiscountRequest.params.keyword; //  검색어 입력
      excelDownRequest.params.promotionKeywordType = this.searchAfterInfo.promotionKeywordType
        ? this.searchAfterInfo.promotionKeywordType
        : this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionKeywordType; //  促销搜索关键字类型
      excelDownRequest.params.memberGradeNo = this.searchAfterInfo.memberGradeNo ? this.searchAfterInfo.memberGradeNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGradeNo; //  会员等级
      excelDownRequest.params.memberGroupNo = this.searchAfterInfo.memberGroupNo ? this.searchAfterInfo.memberGroupNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGroupNo; //  会员组
      excelDownRequest.params.promotionType = this.searchAfterInfo.promotionType ? this.searchAfterInfo.promotionType : this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionType; //  宣传搜索类型
      excelDownRequest.params.discountNo = null;
      let fileName = `Sales_Statistic_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}_${dateNow}.xlsx`;
      this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
        let blob = new window.Blob([res.data], {type: 'blob'});
        if ('download' in document.createElement('a')) {
          // 非IE下载
          let elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    });*/

    private excelComprehensiveDown (){
      //let dateNow = new Date().getTime();
      const excelDownRequest = {...this.excelDownRequest};
      excelDownRequest.params.discountNo =null;
      excelDownRequest.params.mallNo = this.searchAfterInfo.mallNo ? this.searchAfterInfo.mallNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo; // * mall
      excelDownRequest.params.endYmd = this.retEndYmd ? this.retEndYmd : this.startDate; // *  结束日期
      excelDownRequest.params.startYmd = this.retStartYmd ? this.retStartYmd : this.endDate; // *  开始日期
      excelDownRequest.params.genderTypes = this.searchAfterInfo.genderTypes ? this.searchAfterInfo.genderTypes : this.getStatisticsPromotionsAdditionalDiscountRequest.params.genderTypes; // *  会员性别
      excelDownRequest.params.memberType = this.searchAfterInfo.memberType ? this.searchAfterInfo.memberType : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberType; // * 会员类型
      excelDownRequest.params.platformTypes = this.searchAfterInfo.platformTypes ? this.searchAfterInfo.platformTypes : this.getStatisticsPromotionsAdditionalDiscountRequest.params.platformTypes; // * 平台类型（pc web app）
      excelDownRequest.params.page = '1';
      //excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = this.retPartnerNo === '-' ? '' : this.retPartnerNo; //  파트너번호
      excelDownRequest.params.displayBrandNo = this.retBrandName === '-' ? '' : this.retBrandName; //  展览品牌号
      excelDownRequest.params.includesClaim = this.searchAfterInfo.includesClaim ? this.searchAfterInfo.includesClaim : this.getStatisticsPromotionsAdditionalDiscountRequest.params.includesClaim; //  클레임구분
      excelDownRequest.params.keyword = this.searchAfterInfo.keyword ? this.searchAfterInfo.keyword : this.getStatisticsPromotionsAdditionalDiscountRequest.params.keyword; //  검색어 입력
      excelDownRequest.params.promotionKeywordType = this.searchAfterInfo.promotionKeywordType
        ? this.searchAfterInfo.promotionKeywordType
        : this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionKeywordType; //  促销搜索关键字类型
      excelDownRequest.params.memberGradeNo = this.searchAfterInfo.memberGradeNo ? this.searchAfterInfo.memberGradeNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGradeNo; //  会员等级
      excelDownRequest.params.memberGroupNo = this.searchAfterInfo.memberGroupNo ? this.searchAfterInfo.memberGroupNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGroupNo; //  会员组
      excelDownRequest.params.promotionType = this.searchAfterInfo.promotionType ? this.searchAfterInfo.promotionType : this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionType; //  宣传搜索类型
      excelDownRequest.params.discountNo = null;

      if (this.dateType === 'MONTH') {
        const tempDates = getFirstAndEndDay(this.year, this.month);
        excelDownRequest.params.startYmd = tempDates.startYmd;
        excelDownRequest.params.endYmd = tempDates.endYmd;
      }

      const period = `${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}`;
      createExcel(this, this.discountContents.length > 0, excelDownRequest.params, 'PREMIUM_STATISTICS_PROMOTION_ADDITIONAL_DISCOUNT', period)
      /*let fileName = `Sales_Statistic_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}_${dateNow}.xlsx`;
      this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
        let blob = new window.Blob([res.data], {type: 'blob'});
        if ('download' in document.createElement('a')) {
          // 非IE下载
          let elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });*/
    }

    /*$('body').on('click', '.excelDiscountNo', (e) => {
      //dateNow = new Date().getTime();
      this.excelComprehensive();
      excelDownRequest.params.mallNo = this.searchAfterInfo.mallNo ? this.searchAfterInfo.mallNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo; // * mall
      excelDownRequest.params.endYmd = this.retEndYmd ? this.retEndYmd : this.startDate; // *  结束日期
      excelDownRequest.params.startYmd = this.retStartYmd ? this.retStartYmd : this.endDate; // *  开始日期
      excelDownRequest.params.genderTypes = this.searchAfterInfo.genderTypes ? this.searchAfterInfo.genderTypes : this.getStatisticsPromotionsAdditionalDiscountRequest.params.genderTypes; // *  会员性别
      excelDownRequest.params.memberType = this.searchAfterInfo.memberType ? this.searchAfterInfo.memberType : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberType; // * 会员类型
      excelDownRequest.params.platformTypes = this.searchAfterInfo.platformTypes ? this.searchAfterInfo.platformTypes : this.getStatisticsPromotionsAdditionalDiscountRequest.params.platformTypes; // * 平台类型（pc web app）
      excelDownRequest.params.page = '1';
      excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = this.retPartnerName === '-' ? '' : this.retPartnerName; //  파트너번호
      excelDownRequest.params.displayBrandNo = this.retBrandName === '-' ? '' : this.retBrandName; //  展览品牌号
      excelDownRequest.params.includesClaim = this.searchAfterInfo.includesClaim ? this.searchAfterInfo.includesClaim : this.getStatisticsPromotionsAdditionalDiscountRequest.params.includesClaim; //  클레임구분
      excelDownRequest.params.keyword = this.searchAfterInfo.keyword ? this.searchAfterInfo.keyword : this.getStatisticsPromotionsAdditionalDiscountRequest.params.keyword; //  검색어 입력
      excelDownRequest.params.promotionKeywordType = this.searchAfterInfo.promotionKeywordType
        ? this.searchAfterInfo.promotionKeywordType
        : this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionKeywordType; //  促销搜索关键字类型
      excelDownRequest.params.memberGradeNo = this.searchAfterInfo.memberGradeNo ? this.searchAfterInfo.memberGradeNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGradeNo; //  会员等级
      excelDownRequest.params.memberGroupNo = this.searchAfterInfo.memberGroupNo ? this.searchAfterInfo.memberGroupNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGroupNo; //  会员组
      excelDownRequest.params.promotionType = this.searchAfterInfo.promotionType ? this.searchAfterInfo.promotionType : this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionType; //  宣传搜索类型
      excelDownRequest.params.discountNo = e.currentTarget.attributes[3].value;
      excelDownRequest.params.size = this.getStatisticsPromotionsAdditionalDiscountRequest.params.size;
      excelDownRequest.params.page = this.getStatisticsPromotionsAdditionalDiscountRequest.params.page;

      let fileName = `Sales_Statistic_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}_${dateNow}.xlsx`;
      this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
        let blob = new window.Blob([res.data], {type: 'blob'});
        if ('download' in document.createElement('a')) {
          // 非IE下载
          let elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    });
  }*/
  //excelDiscountNo
  private excelDiscountNoDown(e: any) {
    //let dateNow = new Date().getTime();
    const excelDownRequest = {...this.excelDownRequest};
    excelDownRequest.params.mallNo = this.searchAfterInfo.mallNo ? this.searchAfterInfo.mallNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo; // * mall
    excelDownRequest.params.endYmd = this.retEndYmd ? this.retEndYmd : this.startDate; // *  结束日期
    excelDownRequest.params.startYmd = this.retStartYmd ? this.retStartYmd : this.endDate; // *  开始日期
    excelDownRequest.params.genderTypes = this.searchAfterInfo.genderTypes ? this.searchAfterInfo.genderTypes : this.getStatisticsPromotionsAdditionalDiscountRequest.params.genderTypes; // *  会员性别
    excelDownRequest.params.memberType = this.searchAfterInfo.memberType ? this.searchAfterInfo.memberType : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberType; // * 会员类型
    excelDownRequest.params.platformTypes = this.searchAfterInfo.platformTypes ? this.searchAfterInfo.platformTypes : this.getStatisticsPromotionsAdditionalDiscountRequest.params.platformTypes; // * 平台类型（pc web app）
    excelDownRequest.params.page = '1';
    excelDownRequest.params.size = '30';
    excelDownRequest.params.partnerNo = this.retPartnerNo === '-' ? '' : this.retPartnerNo; //  파트너번호
    excelDownRequest.params.displayBrandNo = this.retBrandName === '-' ? '' : this.retBrandName; //  展览品牌号
    excelDownRequest.params.includesClaim = this.searchAfterInfo.includesClaim ? this.searchAfterInfo.includesClaim : this.getStatisticsPromotionsAdditionalDiscountRequest.params.includesClaim; //  클레임구분
    excelDownRequest.params.keyword = this.searchAfterInfo.keyword ? this.searchAfterInfo.keyword : this.getStatisticsPromotionsAdditionalDiscountRequest.params.keyword; //  검색어 입력
    excelDownRequest.params.promotionKeywordType = this.searchAfterInfo.promotionKeywordType
      ? this.searchAfterInfo.promotionKeywordType
      : this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionKeywordType; //  促销搜索关键字类型
    excelDownRequest.params.memberGradeNo = this.searchAfterInfo.memberGradeNo ? this.searchAfterInfo.memberGradeNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGradeNo; //  会员等级
    excelDownRequest.params.memberGroupNo = this.searchAfterInfo.memberGroupNo ? this.searchAfterInfo.memberGroupNo : this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGroupNo; //  会员组
    excelDownRequest.params.promotionType = this.searchAfterInfo.promotionType ? this.searchAfterInfo.promotionType : this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionType; //  宣传搜索类型
    //excelDownRequest.params.discountNo = e.currentTarget.attributes[3].value;
    excelDownRequest.params.discountNo = $(e.target).data('discountno');
    excelDownRequest.params.size = this.getStatisticsPromotionsAdditionalDiscountRequest.params.size;
    excelDownRequest.params.page = this.getStatisticsPromotionsAdditionalDiscountRequest.params.page;

    if (this.dateType === 'MONTH') {
      const tempDates = getFirstAndEndDay(this.year, this.month);
      excelDownRequest.params.startYmd = tempDates.startYmd;
      excelDownRequest.params.endYmd = tempDates.endYmd;
    }

    const discountPeriod = `${excelDownRequest.params.discountNo}_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}`;
    createExcel(this, this.discountContents.length > 0, excelDownRequest.params, 'PREMIUM_STATISTICS_PROMOTION_ADDITIONAL_DISCOUNT_DETAIL', discountPeriod);
    //let fileName = `Sales_Statistic_${this.replaceFileNm(excelDownRequest.params.startYmd)}_${this.replaceFileNm(excelDownRequest.params.endYmd)}_${dateNow}.xlsx`;
    /*this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
      let blob = new window.Blob([res.data], {type: 'blob'});
      if ('download' in document.createElement('a')) {
        // 非IE下载
        let elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    });*/
  }

  private setIsNaverPayMall() {
    this.malls.forEach((mallInfo: Mall) => {
      let naverPayMall = false;
      const orderConfigRequest = {
        pathParams: {
          mallNo: String(mallInfo.mallNo)
        },
        params: {
          key: 'ORDER_CONFIG' // 결제수단 조회
        }
      };
      this.$api.getMallsConfigurations(orderConfigRequest).then((ret) => {
        if (ret && ret.data) {
          naverPayMall = ret.data.useNaverPay;
          if (naverPayMall) {
            this.useNaverPay = naverPayMall;
            return;
          }
        }
      });
    });
  }

  private async getMemberTypes() {
     $('#loading').show();
     this.memberTypes=[];
     const mallNo = this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo;
     const ret = await this.$api.getStatisticsMemberTypes({params: {mallNo: mallNo.toString()}});
     ret.data.forEach((item) => {
        this.memberTypes.push({
          memberTypeValue: item.type,
          memberTypeName: item.label
        })
      });
      this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberType = this.memberTypes[0].memberTypeValue;
      $('#loading').hide();
  }

  private async getGrades() {
    $('#loading').show();
    this.grades = [
      {
        memberGradeNoValue: 0,
        memberGradeNoName: 'STATISTIC_PROMOTION_ALL'
      }
    ];
    const mallNo = this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo;
    const memberGradeList = await this.$api.getMemberGrades({params: {mallNo: Number(mallNo)}});  // used 이거 없는 타입인데... 그래서 삭제
    const sortGrade = await memberGradeList.data.sort((a: Grade, b: Grade) => a.order - b.order);
    if (sortGrade && sortGrade.length) {
      const resGrade = sortGrade.filter(item => item.used);
      resGrade.forEach((grade: Grade) => {
        this.grades.push({
          memberGradeNoValue: grade.no,
          memberGradeNoName: grade.name
        });
      });
    }
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGradeNo = String(this.grades[0].memberGradeNoValue);
    $('#loading').hide();
    return this.grades;
  }

  private async getGroups() {
    $('#loading').show();
    this.memberGroups = [
      {
        memberGroupNoValue: 0,
        memberGroupNoName: 'STATISTIC_PROMOTION_ALL'
      },
      {
        memberGroupNoValue: -1,
        memberGroupNoName: 'STATISTIC_SALES_PERIOD_GROUP_NOT_SET'
      }
    ];
    const mallNo = this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo;
    const memberGroupList = await this.$api.getMemberGroups({params: {mallNo: Number(mallNo)}});
    const sortGroup = await memberGroupList.data.sort((a: Group, b: Group) => b.order - a.order);
    if (sortGroup && sortGroup.length) {
      sortGroup.forEach((group: Group) => {
        this.memberGroups.push({
          memberGroupNoValue: group.no,
          memberGroupNoName: group.name
        });
      });
    }
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGroupNo = String(this.memberGroups[0].memberGroupNoValue);
    $('#loading').hide();
    return this.memberGroups;
  }

  // 조회
  private async search(page: number = 1, size: number) {
    if (this.issuableGenderTypes.join(',') === '') {
      alert(this.$t('VERIFY_MESSAGE_GENDER'));
      return false;
    }
    const noData = this.$t('STATISTIC_SALES_PERIOD_SEARCH_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    if (size) {
      this.getStatisticsPromotionsAdditionalDiscountRequest.params.size = String(size);
    }

    Object.assign(this.getStatisticsPromotionsAdditionalDiscountRequest.params, {page});
    let startDateTime = '';
    let endDateTime = '';
    if (this.dateType === 'MONTH') {
      const tempDates = getFirstAndEndDay(this.year, this.month);
      startDateTime = tempDates.startYmd;
      endDateTime = tempDates.endYmd;
    } else if (this.dateType === 'PERIOD') {
      startDateTime = (this.$refs.combinedPeriod as any).startYmdt;
      endDateTime = (this.$refs.combinedPeriod as any).endYmdt;
    }
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.startYmd = startDateTime;
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.endYmd = endDateTime;
    let mallName = '';
    this.malls.forEach((mallInfo: Mall) => {
      if (mallInfo.mallNo === Number(this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo)) {
        mallName = mallInfo.mallName;
        return;
      }
    });
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.genderTypes = this.issuableGenderTypes.join(',');
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.platformTypes = this.issuablePlatformTypes.join(',');
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.displayBrandNo = this.selectedBrand?.targetNo ? this.selectedBrand.targetNo : '';
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.partnerNo = this.selectedPartner ? this.selectedPartner.targetNo : '';
    $('#loading').show();
    await this.$api
      .getStatisticsPromotionsAdditionalDiscountSummary(this.getStatisticsPromotionsAdditionalDiscountRequest)
      .then((ret) => {
        const {data} = ret;
        if (this.dateType === 'PERIOD' && data.startYmd) {
          this.retStartYmd = data.startYmd;
          this.retEndYmd = data.endYmd;
          this.retDateType = 'PERIOD';
        } else if (this.dateType === 'MONTH' && data.startYmd) {
          const dataArray = data.startYmd.split('-');
          this.retYear = dataArray[0];
          this.retMonth = dataArray[1];
          this.retDateType = 'MONTH';
        }
        this.retMallName = mallName;
        this.discountSummary = [
          {
            totalNumberOfOrders: data.summary.totalOrderCnt,
            totalProductCnt: data.summary.totalProductCnt,
            totalSaleCnt: data.summary.totalSaleCnt,
            totalSaleAmt: data.summary.totalSaleAmt,
            totalAdditionalDiscountAmt: data.summary.totalAdditionalDiscountAmt,
            totalBuyPrice: data.summary.totalSaleAmt - data.summary.totalAdditionalDiscountAmt,
            firstHeader: `${window.$t('STATISTIC_PROMOTION_ADDITIONAL_DISCOUNT_FIRSTHEADER')}`,
            totalMallAmt: data.summary.totalMallAdditionalDiscountAmt,
            totalMallPer: this.getBurdenRatio(data.summary.totalMallAdditionalDiscountAmt, data.summary.totalPartnerAdditionalDiscountAmt).mall,
            totalPartnerAmt: data.summary.totalPartnerAdditionalDiscountAmt,
            totalPartnerPer: this.getBurdenRatio(data.summary.totalMallAdditionalDiscountAmt, data.summary.totalPartnerAdditionalDiscountAmt).partner,
            currencyCode: data.currencyCode,
          }
        ];
        this.retPartnerName = this.getSearchData(this.selectedPartner ? this.selectedPartner.targetName : '');
        this.retPartnerNo = this.getSearchData(this.selectedPartner ? this.selectedPartner.targetNo : '');
        this.retBrandName = this.getSearchData(this.selectedBrand?.targetName ? this.selectedBrand.targetName : '');
      })
      .finally((): any => {
        $('#loading').hide();
      });
    await this.$api
      .getStatisticsPromotionsAdditionalDiscount(this.getStatisticsPromotionsAdditionalDiscountRequest)
      .then((ret) => {
        const {data} = ret;
        this.discountContents = data.contents.map((contentitem: any) => {
          return {
            ...contentitem,
            mallNo: this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo,
            mallName: mallName,
            buyPrice: contentitem.saleAmt - contentitem.mallAdditionalDiscountAmt - contentitem.partnerAdditionalDiscountAmt
          };
        });
        this.totalCount = data.totalCount;
      })
      .finally((): any => {
        $('#loading').hide();
      });
    this.searchAfterData();
  }
  private searchAfterInfo: any = {};
  private searchAfterData() {
    this.searchAfterInfo.mallNo = this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo;
    this.searchAfterInfo.genderTypes = this.getStatisticsPromotionsAdditionalDiscountRequest.params.genderTypes;
    this.searchAfterInfo.memberType = this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberType;
    this.searchAfterInfo.platformTypes = this.getStatisticsPromotionsAdditionalDiscountRequest.params.platformTypes;
    this.searchAfterInfo.includesClaim = this.getStatisticsPromotionsAdditionalDiscountRequest.params.includesClaim;
    this.searchAfterInfo.keyword = this.getStatisticsPromotionsAdditionalDiscountRequest.params.keyword;
    this.searchAfterInfo.promotionKeywordType = this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionKeywordType;
    this.searchAfterInfo.memberGradeNo = this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGradeNo;
    this.searchAfterInfo.memberGroupNo = this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberGroupNo;
    this.searchAfterInfo.promotionType = this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionType;
  }
  private getSearchData(value: string) {
    return value === '' || value === undefined ? '-' : value;
  }

  private getBurdenRatio(mallAmt: number, partnerAmt: number) {
    let totalMallBurdenPer = 0;
    let totalPartnerBurdenPer = 0;
    if (mallAmt === 0 && partnerAmt === 0) {
      totalMallBurdenPer = 0;
      totalPartnerBurdenPer = 0;
    } else if (mallAmt === 0) {
      totalPartnerBurdenPer = 100;
    } else if (partnerAmt === 0) {
      totalMallBurdenPer = 100;
    } else {
      const allAmt = mallAmt + partnerAmt;
      totalMallBurdenPer = Number(((mallAmt / allAmt) * 100).toFixed(2));
      totalPartnerBurdenPer = Number(((partnerAmt / allAmt) * 100).toFixed(2));
    }

    return {mall: totalMallBurdenPer, partner: totalPartnerBurdenPer};
  }

  /** 화폐단위 추가 */
  private addCurrencyCode({ value, currencyCode = 'KRW' }: { value: any, currencyCode?: string}) {
    const formatValue = formatCurrency(value);

    return `${formatValue} ${currencyCode === 'KRW' ? '원' : currencyCode}`;
  }

  // 초기화
  private reset() {
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.mallNo = String(this.malls[0].mallNo);
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.memberType = String(this.memberTypes[0].memberTypeValue);
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.includesClaim = String(this.includesClaims[0].includesClaimValue);
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.promotionKeywordType = String(this.promotionKeywordTypes[0].promotionKeywordTypeValue);
    this.getGrades();
    this.getGroups();
    this.dateType = 'PERIOD';
    this.startDate = addMonth(new Date(), -1);
    this.endDate = getToday();
    (this.$refs.combinedPeriod as any).clickPeriod('1m');
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.keyword = '';
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.genderTypes = 'ALL';
    (this.$refs.issuableGenderTypes as any).setValues('ALL', 'MALE', 'FEMALE', 'UNKNOWN');
    this.getStatisticsPromotionsAdditionalDiscountRequest.params.platformTypes = 'ALL';
    (this.$refs.issuablePlatform as any).setValues('ALL', 'PC', 'MOBILE_WEB', 'MOBILE_APP');
    this.partnerName = '';
    this.selectedBrand = {
      targetName: '',
      targetNo: '',
      couponTargetType: 'BRAND'
    };
    this.selectedPartner = {
      targetName: '',
      targetNo: '',
      couponTargetType: 'PARTNER'
    };
    (this.$refs.brandSearcherRef as BrandSearcher)?.resetBrand();
  }

  // 추가할인 판매현황 종합
  summary1GridProps = {
    header: {
      height: 40,
      columns: [
        {
          name: 'totalBuyPrice',
          renderer: ({columnInfo}: any): any => {
            const div = document.createElement('div');
            div.innerHTML = columnInfo.header.split('@').join('<br>');
            return {
              getElement(): any {
                return div;
              },
              render(): void {}
            };
          }
        }
      ]
    },
    columns: [
      {
        header: 'STATISTIC_PROMOTION_NUMBER_OF_SALES_HEADER',
        name: 'totalNumberOfOrders',
        align: 'center',
        minWidth: 167,
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_NUMBER_OF_PRODUCTS_SOLD',
        name: 'totalProductCnt',
        minWidth: 167,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_SALES_QUANTITY',
        name: 'totalSaleCnt',
        minWidth: 167,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_SALES_AMOUNT_A',
        name: 'totalSaleAmt',
        minWidth: 167,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_ADDITIONAL_DISCOUNT_AMOUNT_B',
        name: 'totalAdditionalDiscountAmt',
        minWidth: 167,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_PRODUCT_SALES_AMOUNT_C',
        name: 'totalBuyPrice',
        minWidth: 167,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_VIEW_DETAILS',
        name: 'excelBtn',
        width: 172,
        align: 'center',
        formatter: function (rowData: any) {
          return `<button type="button" class="excelBtn excelComprehensive" data-mall-no="${rowData.mallNo}" ></span>${window.$t('STATISTIC_PROMOTION_DOWNLOAD')}</button>`;
        },
        copyOptions: {
          useFormattedValue: false,
        }
      }
    ],
    options: {
      columnOptions: {
        minWidth: 10,
        resizable: true
      },
      minBodyHeight: 33,
      rowHeight: 33,
      minRowHeight: 33,
      isInitialRequest: true,
      useClientSort: false,
      copyOptions: {
        useFormattedValue: true
      },
      scrollX: false,
      scrollY: false,
      pageOptions: {}
    }
  };
  summary2GridProps = {
    columns: [
      {
        header: 'STATISTIC_PROMOTION_DIVISION',
        name: 'firstHeader',
        align: 'center',
        minWidth: 198
      },
      {
        header: 'STATISTIC_PROMOTION_TOTAL_DISCOUNT_AMOUNT',
        name: 'totalAdditionalDiscountAmt',
        minWidth: 198,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_DISCOUNT_AMOUNT',
        name: 'totalMallAmt',
        minWidth: 198,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_RATIO',
        name: 'totalMallPer',
        minWidth: 198,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_DISCOUNT_AMOUNT',
        name: 'totalPartnerAmt',
        minWidth: 198,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_RATIO',
        name: 'totalPartnerPer',
        minWidth: 197,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      }
    ],
    options: {
      header: {
        height: 65,
        complexColumns: [
          {
            header: 'STATISTIC_PROMOTION_SHOPPING_MALL_BURDEN',
            name: 'mergeMall',
            childNames: ['totalMallAmt', 'totalMallPer']
          },
          {
            header: 'STATISTIC_PROMOTION_PARTNER_BURDEN',
            name: 'mergePartner',
            childNames: ['totalPartnerAmt', 'totalPartnerPer']
          }
        ]
      },
      columnOptions: {
        minWidth: 10,
        resizable: true
      },
      minBodyHeight: 33,
      rowHeight: 33,
      minRowHeight: 33,
      isInitialRequest: true,
      useClientSort: false,
      noBorder: true,
      scrollX: false,
      scrollY: false,
      pageOptions: {}
    }
  };
  gridResult = {
    header: {
      height: 65,
      columns: [
        {
          name: 'buyPrice',
          renderer: ({columnInfo}: any): any => {
            const div = document.createElement('div');
            div.innerHTML = columnInfo.header.split('@').join('<br>');
            return {
              getElement(): any {
                return div;
              },
              render(): void {}
            };
          }
        }
      ]
    },
    columns: [
      {
        header: 'STATISTIC_PROMOTION_SHOPPING_MALL',
        name: 'mallName',
        align: 'center',
        minWidth: 116
      },
      {
        header: 'STATISTIC_PROMOTION_ADDITIONAL_DISCOUNT_NUMBER',
        name: 'discountNo',
        width: 116,
        align: 'center'
      },
      {
        header: 'STATISTIC_PROMOTION_ADDITIONAL_DISCOUNT_NAME',
        name: 'discountName',
        width: 156,
        align: 'center'
      },
      {
        header: 'STATISTIC_PROMOTION_NUMBER_OF_SALES_HEADER',
        name: 'totalOrderCnt',
        width: 96,
        align: 'center'
      },
      {
        header: 'STATISTIC_PROMOTION_SALES_QUANTITY',
        name: 'totalSaleCnt',
        width: 96,
        align: 'center',
        formatter: function (cell: any) {
          return formatCurrency(cell.value);
        }
      },
      {
        header: 'STATISTIC_PROMOTION_SALES_AMOUNT_A',
        name: 'saleAmt',
        width: 116,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_MALLADDITIONALDISCOUNTAMTBONE',
        name: 'mallAdditionalDiscountAmt',
        width: 166,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_MALLADDITIONALDISCOUNTAMTBTOW',
        name: 'partnerAdditionalDiscountAmt',
        width: 166,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_MALLADDITIONALDISCOUNTAMTC',
        name: 'buyPrice',
        width: 196,
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({value: data.value, currencyCode: data.row.currencyCode })
      },
      {
        header: 'STATISTIC_PROMOTION_VIEW_DETAILS',
        name: 'excelBtn',
        width: 113,
        align: 'center',
        formatter: function (rowData: any) {
          return `<button type="button" class="excelBtn excelDiscountNo" data-mall-no="${rowData.mallNo}" data-discountNo="${rowData.row.discountNo}" ></span>${window.$t(
            'STATISTIC_PROMOTION_DOWNLOAD'
          )}</button>`;
        },
        copyOptions: {
          useFormattedValue: false,
        }
      }
    ],
    options: {
      columnOptions: {
        minWidth: 10,
        resizable: true
      },
      rowHeight: 35,
      minRowHeight: 35,
      displayRowCount: 15,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        page: 1,
        perPage: 30,
        totalCount: 0
      }
    }
  };

  private goPage(url: string) {
    if (this.$route.path === url) {
      this.$router.go(0);
      return;
    }
    this.$router.push({path: url});
  }

  private replaceFileNm(fileName:string) {
    let fileNm = '';
    if (fileName){
      fileNm = fileName.replaceAll('-','');
    }
    return fileNm;
  }

  protected beforeDestroy(): void {
    $('body').off('click', '.excelComprehensive', $.proxy(this.excelComprehensiveDown, this));
    $('body').off('click', '.excelDiscountNo', $.proxy(this.excelDiscountNoDown, this));
    //$('body').off('click', '.excelComprehensive');
   // $('body').off('click', '.excelDiscountNo');
  }
}
